var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCryptoWallet(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.5 22.15H20.5C21.4098 22.15 22.15 21.4098 22.15 20.5V16.5C22.15 16.1411 21.8588 15.85 21.5 15.85C21.1412 15.85 20.85 16.1411 20.85 16.5V20.5C20.85 20.6921 20.6922 20.85 20.5 20.85H2.5C1.75584 20.85 1.15 20.2441 1.15 19.5V3.49998C1.15 3.14114 0.858843 2.84998 0.5 2.84998C0.141157 2.84998 -0.15 3.14114 -0.15 3.49998V19.5C-0.15 20.9618 1.03816 22.15 2.5 22.15Z",
    fill: "#A6AAB0",
    stroke: "#A6AAB0",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.54516 4.44713L1.54519 4.44711L1.54292 4.44489C1.29023 4.19758 1.15 3.86343 1.15 3.50009C1.15 2.75593 1.75584 2.15009 2.5 2.15009H17.5C17.6922 2.15009 17.85 2.30793 17.85 2.50009V4.85009H2.5C2.13743 4.85009 1.80302 4.71041 1.54516 4.44713ZM20.85 10.5001C20.85 10.8589 21.1412 11.1501 21.5 11.1501C21.8588 11.1501 22.15 10.8589 22.15 10.5001V6.50009C22.15 5.59025 21.4098 4.85009 20.5 4.85009H19.15V2.50009C19.15 1.59025 18.4098 0.850092 17.5 0.850092H2.5C1.03816 0.850092 -0.15 2.03825 -0.15 3.50009C-0.15 4.21388 0.128115 4.88036 0.624938 5.36518C1.1194 5.87164 1.78573 6.15009 2.5 6.15009H20.5C20.6922 6.15009 20.85 6.30793 20.85 6.50009V10.5001Z",
    fill: "#A6AAB0",
    stroke: "#A6AAB0",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5 17.1501H23.5C23.8588 17.1501 24.15 16.8589 24.15 16.5001V10.5001C24.15 10.1412 23.8588 9.85009 23.5 9.85009H18.5C17.5261 9.85009 16.61 10.23 15.9199 10.92C15.2299 11.6101 14.85 12.5262 14.85 13.5001C14.85 15.5129 16.4872 17.1501 18.5 17.1501ZM16.839 11.8393C17.284 11.3951 17.874 11.1501 18.5 11.1501H22.85V15.8501H18.5C17.2038 15.8501 16.15 14.7962 16.15 13.5001C16.15 12.8739 16.3942 12.2831 16.839 11.8393Z",
    fill: "#A6AAB0",
    stroke: "#A6AAB0",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5 15C17.673 15 17 14.327 17 13.5C17 12.673 17.673 12 18.5 12C19.327 12 20 12.673 20 13.5C20 14.327 19.327 15 18.5 15ZM18.5 13C18.225 13 18 13.225 18 13.5C18 13.775 18.225 14 18.5 14C18.775 14 19 13.775 19 13.5C19 13.225 18.775 13 18.5 13Z",
    fill: "#A6AAB0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.5 13.5001C8.224 13.5001 8 13.2761 8 13.0001C8 12.7241 8.224 12.5001 8.5 12.5001C9.052 12.5001 9.5 12.0521 9.5 11.5001C9.5 10.9481 9.052 10.5001 8.5 10.5001H6V13.0001C6 13.2761 5.776 13.5001 5.5 13.5001C5.224 13.5001 5 13.2761 5 13.0001V10.0001C5 9.72409 5.224 9.50009 5.5 9.50009H8.5C9.603 9.50009 10.5 10.3971 10.5 11.5001C10.5 12.6031 9.603 13.5001 8.5 13.5001Z",
    fill: "#A6AAB0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 16.5001H5.5C5.224 16.5001 5 16.2761 5 16.0001V13.0001C5 12.7241 5.224 12.5001 5.5 12.5001H9C10.103 12.5001 11 13.3971 11 14.5001C11 15.6031 10.103 16.5001 9 16.5001ZM6 15.5001H9C9.552 15.5001 10 15.0521 10 14.5001C10 13.9481 9.552 13.5001 9 13.5001H6V15.5001Z",
    fill: "#A6AAB0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.5 10.5001C6.224 10.5001 6 10.2761 6 10.0001V8.50009C6 8.22409 6.224 8.00009 6.5 8.00009C6.776 8.00009 7 8.22409 7 8.50009V10.0001C7 10.2761 6.776 10.5001 6.5 10.5001Z",
    fill: "#A6AAB0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.5 10.5001C8.224 10.5001 8 10.2761 8 10.0001V8.50009C8 8.22409 8.224 8.00009 8.5 8.00009C8.776 8.00009 9 8.22409 9 8.50009V10.0001C9 10.2761 8.776 10.5001 8.5 10.5001Z",
    fill: "#A6AAB0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.5 18.0001C8.224 18.0001 8 17.7761 8 17.5001V16.0001C8 15.7241 8.224 15.5001 8.5 15.5001C8.776 15.5001 9 15.7241 9 16.0001V17.5001C9 17.7761 8.776 18.0001 8.5 18.0001Z",
    fill: "#A6AAB0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.5 18.0001C6.224 18.0001 6 17.7761 6 17.5001V16.0001C6 15.7241 6.224 15.5001 6.5 15.5001C6.776 15.5001 7 15.7241 7 16.0001V17.5001C7 17.7761 6.776 18.0001 6.5 18.0001Z",
    fill: "#A6AAB0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCryptoWallet);
export default __webpack_public_path__ + "static/media/crypto-wallet.4399a3f0.svg";
export { ForwardRef as ReactComponent };